// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path
      fillRule="evenodd"
      d="M13 15v-4a1 1 0 0 0-1-1h-2v2h1v3H9v2h6v-2Zm0-7.5A1.5 1.5 0 1 1 11.5 6 1.5 1.5 0 0 1 13 7.5ZM12 4a8 8 0 1 0 8 8 8 8 0 0 0-8-8Zm0 18a10 10 0 1 1 10-10 10 10 0 0 1-10 10Z"
    />
  </BaseIcon>
)
